<template>
  <v-row justify="center">
    <slot></slot>
    <v-dialog scrollable max-width="400px" v-model="showDialog">
      <template v-slot:activator="{ on }">
        <v-btn right text v-on="on" x-small class="text-left blue--text mx-8"
          >¿olvidó su contraseña?</v-btn
        >
      </template>
      <v-card>
        <v-card-title>Recuperar contraseña</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="my-2">
          <h4 class="text-left pa-4 ma-2">
            Por favor, ingresá tu número de cédula y la dirección de correo
            electrónico asociada a tu usuario. Vas a recibir un correo con las
            instrucciones para recuperar tu contraseña.
          </h4>
          <v-form ref="form" v-model="validForm">
            <v-text-field
              label="Número de Cédula"
              prepend-icon="mdi-account-circle"
              :rules="[rules.required]"
              v-model="cedula"
            ></v-text-field>
            <v-text-field
              label="Dirección de correo electrónico"
              type="text"
              :rules="[rules.required, rules.email]"
              prepend-icon="mdi-lock"
              @click:append="showPassword = !showPassword"
              v-model="email"
            ></v-text-field>
          </v-form>
          <v-alert type="error" v-if="errorMessage">
            {{ errorMessage }}
          </v-alert>
          <v-alert type="success" v-if="message">
            {{ message }}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn big color="primary" outlined @click="clicked('NO')"
            >VOLVER</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            :loading="loading"
            :disabled="message != '' || !validForm"
            color="primary"
            @click="requestResetPassword"
            >RECUPERAR</v-btn
          >
        </v-card-actions>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script lang="ts">
import Vue from "vue";
import axios from "../../axios-auth";

export default Vue.extend({
  data() {
    return {
      showDialog: false,
      cedula: "",
      email: "",
      password: "123",
      showPassword: false,
      message: "",
      errorMessage: "",
      validForm: false,
      loading: false,
      rules: {
        required: value => !!value || "Requerido.",
        counter: value => value.length <= 1000 || "Maximo 100 caracteres",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "correo electrónico invalido.";
        }
      }
    };
  },
  methods: {
    requestResetPassword() {
      this.loading = true;
      this.errorMessage = "";
      this.message = "";
      console.log(this.username, this.email);
      axios
        .post("/singup/resetPassword", {
          cedula: this.cedula,
          correo: this.email
        })
        .then(response => {
          this.loading = false;
          this.message = "¡Se envió el mensaje a su dirección de correo!";
          console.log(response);
        })
        .catch(err => {
          this.loading = false;
          this.errorMessage = "Cédula y/o dirección de correo inválido";
          console.log(err);
        });
    },
    clicked(valor) {
      if (valor == "SI") {
        this.$emit("si");
      } else {
        this.$emit("no");
      }
      this.showDialog = false;
    }
  }
});
</script>
